import { clone, indexOf, isNull, isUndefined, max } from 'lodash';

import { Increment } from 'core/rating/types';

export const generateInputWidthPctg = (increment: Increment): string => {
    let width = '';

    switch (increment) {
        case Increment.Whole:
            width = '100%';
            break;
        case Increment.Half:
            width = '50%';
            break;
        // case Increment.Point:
        default:
            width = '10%';
    }

    return width;
};

export const generateValueNotationWidthPctg = (incrementedValues: number[], selectedValue?: number | null): string => {
    const incrementedValuesSorted = clone(incrementedValues).sort();
    let width;

    if (isNull(selectedValue) || isUndefined(selectedValue)) {
        width = '0%';
    } else if (selectedValue >= (max(incrementedValuesSorted) as number)) {
        width = '100%';
    } else {
        const indexOfSelectedValue = indexOf(incrementedValuesSorted, Math.round(selectedValue * 10) / 10);
        const indexAsPctg =
            indexOfSelectedValue === -1 ? 0 : (indexOfSelectedValue + 1) / incrementedValuesSorted.length;

        width = `${indexAsPctg * 100}%`;
    }

    return width;
};
